// src/api/useFetchObjects.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const useFetchObjects = (queryKey, endpoint, token, options = {}) => {
  const auth = useAuth();
  const hasHeaderToken = Boolean(auth?.buildAuthHeader?.().Authorization);
  const queryEnabled =
    options.enabled !== undefined
      ? options.enabled
      : !!(endpoint && endpoint !== "" && (token || hasHeaderToken));

  // const queryClient = useQueryClient();
  const fetchFunction = async () => {
    const headers =
      token && typeof token === "string"
        ? auth?.buildAuthHeader?.() || { Authorization: `Token ${token}` }
        : auth?.buildAuthHeader?.() || {};
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`, {
      headers,
    });
    return response.data;
  };

  const { data, isLoading, isError, isSuccess, error, refetch } = useQuery({
    queryKey: queryKey,
    queryFn: fetchFunction,
    enabled: queryEnabled,
    retry: false,
    ...options
  });

  // useEffect(() => {
  //   queryClient.invalidateQueries(queryKey);
  // }, [queryKey]);

  return { data, isLoading, isError, isSuccess, error, refetch };
};

export default useFetchObjects;
